const UK_PHONE_MAX_LENGTH = 12;
const NA_PHONE_MAX_LENGTH = 10;

export const getPhoneMaxLengthByCountry = (country?: string | null): number => {
  if (!country) return NA_PHONE_MAX_LENGTH;
  const normalized = country.toLowerCase();
  if (normalized === 'united kingdom' || normalized === 'gb') return UK_PHONE_MAX_LENGTH;
  return NA_PHONE_MAX_LENGTH;
};
